var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBreadSlice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 32C96 32 0 112.035 0 176.965C0 203 21.557 224 56.889 224H64V448C64 465.674 78.328 480 96 480H416C433.674 480 448 465.674 448 448V224H455.111C490.445 224 512 203 512 176.965C512 112.035 416 32 256 32ZM455.111 208H432V448C432 456.822 424.822 464 416 464H96C87.178 464 80 456.822 80 448V208H56.889C32.432 208 16 195.527 16 176.965C16 124.254 101.467 48 256 48C410.535 48 496 124.254 496 176.965C496 195.527 479.568 208 455.111 208Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadSlice);
export default __webpack_public_path__ + "static/media/bread-slice.2dc28f8d9d6e706076b3ae187b26b0f5.svg";
export { ForwardRef as ReactComponent };